import React from "react"

import { ProductDeliveryTimeUploadView } from "./ProductDeliveryTimeUploadView"
import { ProductDeliveryTimeUploadModel } from "./model/useProductDeliveryTimeUploadModel"

interface ProductDeliveryTimeUploadViewModel
  extends ProductDeliveryTimeUploadModel {}

export const ProductDeliveryTimeUpload = React.memo(
  (props: ProductDeliveryTimeUploadViewModel) => {
    return <ProductDeliveryTimeUploadView {...props} />
  }
)
